import {Model} from '@vuex-orm/core';
import store from "$src/store";

export default class File extends Model {

    static entity = 'file';
    static primaryKey = 'id_file';

    static fields() {
        return {
            id_file: this.number(null),
            name: this.string(''),
            mime_type: this.string(''),
        };
    }

    static defaultAttachmentFormats = [
        'image/jpeg',
        'image/png',
        'application/pdf',
        'video/mpeg',
        'video/x-msvideo',
        'video/mp4',
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/vnd.ms-powerpoint",
        "application/vnd.openxmlformats-officedocument.presentationml.presentation",
        'application/msexcel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    ];

    get url() {
        return store.getters['upload/getContentUrl'](this.id_file);
    }

    get thumbnail() {
        return store.getters['upload/getThumbnailUrl'](this.id_file);
    }

}